import React from 'react';
import Page from '../components/containers/Page';
import { AnimatePresence } from 'framer-motion';
import useMenuModal from '../hooks/useMenuModal';
import { project } from '../data/data';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import Button from '../components/common/Button';
import animA from '../animations/animA';
import ImageMedia from '../components/common/ImageMedia';
import { img_lawwd_card } from '../assets';
import MoveAround from '../components/containers/MoveAround';
import useWindowSize from '../hooks/useWindowSize';
import { twMerge } from 'tailwind-merge';
// import ContactForm from '../components/common/ContactForm copy';

const Contact = () => {
  document.title = `CONTACT — ${project.website}`;


  // TODO : ADD FORM
  // TODO : ADD TOAST ON SUBMIT

  return (
    <Page>
      <div className='w-full min-h-[100dvh] overflow-y-clip relative flex flex-col ===lg:landscape:flex-row'>

        <div className='flex relative center h-[80vh] lg:h-[100dvh] w-full overflow-clip'>
          <MoveAround>
            <ImageMedia src={img_lawwd_card} className="relative scale-[115%] origin-bottom w-full bg-[rgb(226,226,226)] h-full object-contain object-bottom" />
          </MoveAround>
          <div className='absolute inset-x-4 bottom-0 z-[2] mt-auto'>
            <div className='resp paddingY'>
              <Contacts className={"flex lg:flex-row lg:justify-between lg:flex-wrap mx-auto pb-8"} />
            </div>
          </div>
          <div className='absolute inset-0 bottom-0 mt-auto h-[45%] noaction bg-gradient-to-t from-black/80 z-[1]' />
        </div>


     <div className='MOB w-full paddingY ==lg:h-[15dvh] my-auto items-end justify-center'>
          <div className='flex flex-col resp= paddingX w-full items-center justify-between my-auto= gap-2 *:text-sm'>
            <p className='text-left'>© 2025, LAWWD®. Tous droits réservés.</p>
            <p className='text-right'>Conçu et développé par LAWWD.Dev</p>
          </div>
        </div>

        {/* <div className='max-lg:!px-0 resp lg:py-[80px] max-h-[100vh] paddingY'>
          <div className='flex flex-col items-start justify-center min-h-[30vh] h-full overflow-y-auto= center rounded-lg border border1 my-6 bg-neutral-500/5= bg-dark space-y-6 paddingY'>
            <h2 className='resp'>Contactez-nous :&#41; </h2>
            <ContactForm />
          </div>
        </div> */}
      </div>
    </Page>
  )
}

export const Contacts = ({ className }) => {
  const { isOpen } = useMenuModal();
  const { duration, ease } = animA();
  const { onMobile, onDesk } = useWindowSize();
  const pathname = useLocation().pathname;

  return (
    <div className='flex relative'>
      <div className={twMerge('flex lg:flex-col items-center lg:items-start gap-6', className)}>
        <AnimatePresence /* key={contact.label + i} */ mode='wait' >
          {project.contacts.map((contact, i) => {
            return (

              (isOpen || ((onMobile || onDesk) && pathname === "/contact")) && (

                <motion.div key={contact.label + i}
                  initial={{ y: 50, opacity: 0, scale: 1.5 }}
                  animate={{ y: 0, opacity: 1, scale: 1 }}
                  exit={{ y: 5 * (i + 20), opacity: 0, }}
                  transition={{ duration, ease, delay: 0.1 * i + .5 }}
                >
                  <ContactLink {...contact} i={i} />
                </motion.div>

              )
            )
          })}
        </AnimatePresence>
      </div>
    </div>
  )
}

export const ContactLink = ({ i, ...props }) => {
  return (
    <Link id={props.label} target='_blank' to={props.onClick} key={props + i} className='flex group'>
      <div className='flex flex-col lg:flex-row gap-4 center shrink-0'>
        <Button variant={"discreet"} className='flex flex-col center rounded-full border border1 aspect-square size-14 group-hover:bg-white group-hover:text-black quick'>
          <i className={`${props.icon} ri-lg`} />
        </Button>
        <p className='hidden md:flex ml-10= text-left text-sm lg:text-xl muted group-hover:unmute quick'>{props.value}</p>
      </div>
    </Link>
  )
}

export default Contact